module.exports = __webpack_public_path__ + "static/img/华为.0c25245b.jpg";